import { gateway } from "src/gateway";
import { ICreateSetupFeeOrderPayload } from "./pay.setup.fee.interfaces";

export interface FlowMobilePortingCheckout {
  invoiceUid: string;
  checkoutSessionId: string;
  clientSecret: string | null;
  paymentUrl: string | null;
  amount: number;
  currencyCode: string;
  status: "pending_payment";
}

export interface FlowMobilePortingStatus {
  invoiceUid: string;
  status: "pending_payment" | "paid";
  provisioned: boolean;
  paidAt: string | null;
}

export interface FlowMobileBuyingResult {
  status: "pending_payment" | "provisioned";
  subscriptionId: string;
  phoneNumber: string;
}

const unwrap = <T,>(response: { data?: { data?: T } }): T => {
  if (!response?.data?.data) {
    throw new Error("Flow Mobile response did not include data");
  }
  return response.data.data;
};

export const createPortingCheckout = async (setupPayload: ICreateSetupFeeOrderPayload): Promise<FlowMobilePortingCheckout> => {
  const response = await gateway.post("/stripe/flow-mobile/porting/checkout", {
    planId: setupPayload.planId,
    subscriptionId: setupPayload.subscriptionId,
    porting: setupPayload.porting,
  });
  return unwrap<FlowMobilePortingCheckout>(response);
};

export interface FlowMobilePortingLink {
  linked: boolean;
  paid: boolean;
  externalId: string | null;
  phoneNumber: string | null;
}

export const linkPaidPorting = async (subscriptionId: string): Promise<FlowMobilePortingLink> => {
  const response = await gateway.get(`/stripe/flow-mobile/porting/link/${subscriptionId}`);
  return unwrap<FlowMobilePortingLink>(response);
};

export const fetchPortingStatus = async (invoiceUid: string): Promise<FlowMobilePortingStatus> => {
  const response = await gateway.get(`/stripe/flow-mobile/porting/${invoiceUid}`);
  return unwrap<FlowMobilePortingStatus>(response);
};

export const requestIncludedNumber = async (setupPayload: ICreateSetupFeeOrderPayload): Promise<FlowMobileBuyingResult> => {
  const response = await gateway.post("/stripe/flow-mobile/buying", {
    planId: setupPayload.planId,
    subscriptionId: setupPayload.subscriptionId,
    buying: setupPayload.buying,
  });
  return unwrap<FlowMobileBuyingResult>(response);
};

export const fetchBuyingStatus = async (subscriptionId: string): Promise<FlowMobileBuyingResult & { provisioned: boolean }> => {
  const response = await gateway.get(`/stripe/flow-mobile/buying/${subscriptionId}`);
  return unwrap(response);
};
